module.exports = __webpack_public_path__ + "img/play-circle.3acf99bf.svg";